/**
 * Buckets which each OfferingTransaction belonging to a user can be placed in to be displayed in the client.
 */
export enum TransactionCategory {
  RESERVED,
  CANCELLED,
  INCOMPLETE,
  COMPLETED,
}
